export default __webpack_public_path__ + "static/media/img4_2.802d210b.png";